import { LoaderWrapperCSSStyle, LoaderWrapperCSSStyleImpl } from './loaderwrappercss';
import * as React from 'react';
import { UIComponentViewImpl } from '../../toolkit/uicomponentview';
import { UIDataModel } from '../../toolkit/uicomponent';
import { LoaderWrapperComponentProps, LoaderWrapperComponentState } from './loaderwrappercomponent';
import './loaderwrappercss.css';

export class LoaderWrapperViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: LoaderWrapperComponentProps, state: LoaderWrapperComponentState, cssStyle: LoaderWrapperCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
    
        if(state.isShowWindow)
        {
            return (
                <>
                  <div id="loader-web">
                        {
                            this.getWebView(props, state, cssStyle)
                        }
                  </div>
                  <div id="loader-mobile">
                      {
                          this.getMobileView(props, state, cssStyle)
                      }
                  </div>
                </>);
        }
       else{
           return false;
       }
    }

    getWebView(props: LoaderWrapperComponentProps, state: LoaderWrapperComponentState, cssStyle: LoaderWrapperCSSStyle)
    {
        (cssStyle as LoaderWrapperCSSStyleImpl).setChildComponentWidth("440px");
        return (
            <>
             <div id="nodeA" style={cssStyle.getWrapperCSSStyle()}>
                <div id="animatetop" style={cssStyle.getContentDivCSSStyle()}>
                    {
                        state.childComponent
                    }
                </div>
             </div>
           
            </>);
    }

    getMobileView(props: LoaderWrapperComponentProps, state: LoaderWrapperComponentState, cssStyle: LoaderWrapperCSSStyle)
    {
        (cssStyle as LoaderWrapperCSSStyleImpl).setChildComponentWidth("95px");
        return (
            <>
             <div id="nodeA" style={cssStyle.getWrapperCSSStyle()}>
                <div id="animatetop" style={cssStyle.getMobileContentDivCSSStyle()}>
                    {
                        state.childComponent
                    }
                </div>
             </div>
           
            </>);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/loaderwrapperview.tsx